import cornerstone from 'cornerstone-core';

import { formatDICOMDate, formatPN } from '../formatStudy';
import getPatientStudyInfo from '../getPatientStudyInfo';

/**
 * Builds the patient/study block that is repeated on every printed sheet.
 *
 * Patient/study fields come from the study JSON of the API (see
 * getPatientStudyInfo), so edits made to the patient in the API are printed
 * instead of the values stored in the image headers. Series fields come from
 * the cornerstone metadata providers, the same source the viewport overlay reads.
 *
 * @param {string} imageId any imageId of the series being printed
 * @param {Object} [displaySet] used as a fallback for series level fields
 * @returns {Object} { patientName, patientId, studyDate, studyDescription, seriesDescription, modality, institution }
 */
export default function getPrintHeader(imageId, displaySet = {}) {
  const info = getPatientStudyInfo(imageId);
  const series = cornerstone.metaData.get('generalSeriesModule', imageId) || {};

  return {
    patientName: formatPN(info.patientName) || '',
    patientId: info.patientId || '',
    studyDate: info.studyDate ? formatDICOMDate(info.studyDate) : '',
    studyDescription: info.studyDescription || '',
    seriesDescription:
      series.seriesDescription || displaySet.SeriesDescription || '',
    modality: series.modality || displaySet.Modality || '',
    institution: info.institution || '',
  };
}
